import React, { useState } from "react";
import { Popover } from "react-tiny-popover";
import InfoIcon from "../../icons/fillInfoIcon";
import styles from "./style.module.css";

const Tooltip = ({
  content,
  position = ["right"],
  align = "end",
  transform = { top: -15, left: 1 },
  customClass = "",
  customPopoverClass = "",
}) => {
  const [open, setOpen] = useState(false);

  const handleToggle = () => {
    setOpen(!open);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className={`${styles.tooltip} ${customClass}`}>
      <Popover
        containerClassName={`${styles.popover} ${customPopoverClass}`}
        isOpen={open}
        positions={position}
        align={align}
        content={<div className={styles.tooltipContent}>{content}</div>}
        onClickOutside={handleClose}
        transform={transform}
        transformMode="relative"
      >
        <button
          type="button"
          className={`${open ? styles.open : ""}`}
          onMouseEnter={handleToggle}
          onMouseLeave={handleClose}
        >
          <InfoIcon />
        </button>
      </Popover>
    </div>
  );
};

export default Tooltip;
